export default "__VITE_ASSET__edSjQ4Zs__"